import WorkQDeferredCustomSelect from "./WorkQDeferredCustomSelect"
import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { filterActions } from "../../../store/filter"
import { caseQuickUpdate } from "../../../lib/fetchApi"
import { notificationActions } from "../../../store/notifications"
import { mrqRecordUploadViaOptions } from "../../../lib/systemData"

export default function SimpleSelect({data, group, item, caseData, subItem}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const selectedWorkQueue = useSelector(state => state.workqueue.selectedWorkQueue)
    const workqSlug = selectedWorkQueue?.slug || selectedWorkQueue
    const [loading, setLoading] = useState(false)
    const [selectedValue, setSelectedValue] = useState(data)

    useEffect(() => {
        setSelectedValue(data)
    }, [data])

    let identifier
    const allowClearSelectedValue = subItem.key == "case_practices_mrq_record_upload_via_update"

    const options = useMemo(() => {
        let opts = []
        if (subItem.key == "case_practices_mrq_record_upload_via_update") {
            opts = mrqRecordUploadViaOptions()
        }
        if (selectedValue && opts.length > 0) {
            const foundOption = opts.find((option) => option.value == selectedValue)
            if (!foundOption) {
                opts = [...opts, { label: selectedValue, value: selectedValue, isDisabled: true }]
            }
        }
        return opts
    }, [subItem.key, selectedValue])

    if (subItem.key == "case_practices_mrq_record_upload_via_update") {
        identifier = {
            type: 'case_practice', 
            field: 'mrq_record_upload_via', 
            type_id: item.id, 
            folder: 'practices', 
            case_id: caseData.case?.id
        }
    }

    async function updateHandler(data) {
        const previousValue = selectedValue
        const newValue = data?.data?.value
        setSelectedValue(newValue)
        setLoading(true)

        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            workq: workqSlug,
            fields: {
                [data.identifier.field] : newValue,
            }
        }     

        let dispatchBody = {
            case_id: data.identifier.case_id,
            folder: data.identifier.folder,
            item: {
                itemId: data.identifier.type_id,
                fields: [
                    {
                        field: data.identifier.field,
                        value: newValue
                    }
                ]              
            },
        }

        dispatch(filterActions.updateItemInWorkQRow(dispatchBody))

        try {
            let update = await caseQuickUpdate(userToken, data.identifier.case_id, reqBody, null, true)

            if (update && update.errorMessage) {
                setSelectedValue(previousValue)
                dispatch(
                    filterActions.updateItemInWorkQRow({
                        ...dispatchBody,
                        item: {
                            ...dispatchBody.item,
                            fields: [{ field: data.identifier.field, value: previousValue }],
                        },
                    }),
                )
                dispatch(notificationActions.setError(update))
            }
        } finally {
            setLoading(false)
        }
                
    }
    return <div>
        <WorkQDeferredCustomSelect
            fixedDrawer={true}
            hasRemove={allowClearSelectedValue}
            name={item.name}
            sameSizeAsContainer={true}
            minWidth={150}
            preSelectedValue={selectedValue}
            optionsData={options}
            label={item.label}
            identifier={identifier}
            action={updateHandler}
            isLoading={loading}
        />
    </div>
}